import React from "react";
import "./Font.css";

export default function Font() {
  return <h2 className="Font">Hello! Please type in an English word to begin.</h2>;
}